import React from "react";
import OptionModal, {
  OptionModalState,
} from "widgets/configurator/option-modal";

type ModalSetter = React.Dispatch<React.SetStateAction<OptionModalState>>;

const ModalSetterContext = React.createContext<ModalSetter | null>(null);

export function useOptionModalSetter() {
  const ctx = React.useContext(ModalSetterContext);
  if (!ctx) {
    throw new Error(
      "useOptionModalSetter must be used inside <MobileConfiguratorModalTemplate />",
    );
  }
  return ctx;
}

export function MobileConfiguratorModalTemplate({
  children,
}: {
  children: React.ReactNode;
}) {
  const [modalState, setModalState] = React.useState<OptionModalState>({
    isOpen: false,
    heading: "",
    description: "",
  });

  // Children won't re-render when modalState changes,
  // because the child element was created outside this component.
  return (
    <>
      <ModalSetterContext.Provider value={setModalState}>
        {children}
      </ModalSetterContext.Provider>
      <OptionModal modalState={modalState} setModalState={setModalState} />
    </>
  );
}
